import { IDeleteMapaConcretagemUseCase } from "../../../presentation/useCases/delete/delete_mapa_concretagem_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteMapaConcretagemUseCase
 */

export class DeleteMapaConcretagemUseCase implements IDeleteMapaConcretagemUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteMapaConcretagem(
    idMapaConcretagem: number,
  ): Promise<void> {
    await this.repository.deleteMapaConcretagem(
      idMapaConcretagem,
    );
  }
}
